import { render, staticRenderFns } from "./cancelcard.vue?vue&type=template&id=164ba82c&"
import script from "./cancelcard.vue?vue&type=script&lang=js&"
export * from "./cancelcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports